export const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
